import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const DailyBatchLogWorkflowRoute: RouteType = {
  name: "DailyBatchLog",
  path: "/workflows/daily-batch-log",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Daily Batch Log",
      component: () => import("./DailyBatchLogWorkflowHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./DailyBatchLogWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the batch log
      const jobStore = rootStore.jobStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;

      await Promise.all([
        jobStore?.find(),
        productsStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for daily batch log:", error);
      return false;
    }
  },
};

export default DailyBatchLogWorkflowRoute;
